import React from "react"
import "./src/styles/global.css"
import { C2foComponentsRootProvider } from "@c2fo/components__deprecated"
export const wrapRootElement = ({ element }) => {
  return <C2foComponentsRootProvider>{element}</C2foComponentsRootProvider>
}
